import { gql, useMutation } from "@apollo/client";
import useUser from "./useUser";

const BUY_IMAGE_MUTATION = gql`
  mutation BuyImage($ids: [Int!]!) {
    buyImages(ids: $ids)
  }
`;

const useBuyImage = (): {
  loading: boolean;
  error: Error | undefined;
  buy: (id: number) => void;
} => {
  const { refetch } = useUser()[1];

  const [mutate, { loading, error }] = useMutation<{ buyImages: number[] }>(
    BUY_IMAGE_MUTATION,
    {
      update(cache, { data }) {
        const fr = gql`
          fragment ImageFragment on ShopItem {
            bought
          }
        `;
        if (data && data.buyImages.length > 0) {
          cache.writeFragment({
            fragment: fr,
            id: `ShopItem:${data.buyImages[0]}`,
            data: {
              bought: true,
            },
          });
        }
      },
      onCompleted() {
        refetch();
      },
    }
  );
  const buy = async (id: number) => {
    mutate({
      variables: {
        ids: [id],
      },
    });
  };
  return { loading, error, buy };
};

export default useBuyImage;
